<template>
  <section>
    <div class="store-locator">
      <div class="content">
        <StoreForm
          class="form"
          @searchMap="searchMap"
        />
      </div>

      <div class="map">
        <StoreMap :results="results" />
      </div>
    </div>
  </section>
</template>

<script>
import StoreForm from '@/components/utils/store/StoreForm.vue';
import StoreMap from '@/components/utils/store/StoreMap.vue';

export default {
  name: 'StoreLocatorComponent',

  components: {
    StoreForm,
    StoreMap,
  },

  data() {
    return {
      mapRef: null,
      results: null,
    };
  },

  methods: {
    searchMap(results) {
      this.results = results;
    },
  },
};
</script>

<style lang="stylus" scoped>
section {
  max-width: 600px;
  +desktop() {
    max-width: none;
    width: 100%;
  }
}

.store-locator {
  display: flex;
  margin-left: auto; margin-right: @margin-left;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .content {
    width: 100%;
    padding: 0 30px;
    max-width: 340px;

    .image {
      margin: 0 auto;
      +desktop() {
        margin: 0 0 0 auto;
      }
    }

    .title {
      font-weight: 700;
      font-size: 22px;
      text-align: left;
      margin: 20px 0 10px 0;
      +desktop() {
        text-align: right;
      }
    }

    .description {
      font-size: 18px;
      text-align: left;
      margin: 10px 0;
      +desktop() {
        text-align: right;
      }
    }

    .form {
      margin: 20px 0;
      width: 100%
    }
  }

  .map {
    width: 100%;
    aspect-ratio: 16/9;
    height: auto;
    min-height: 500px

    +mobile() {
      aspect-ratio: none;
      height: 480px;
    }
  }
}
</style>
